export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";